if (!customElements.get('quick-add-opener')) {
    customElements.define(
        'quick-add-opener',
        class QuickAddOpener extends HTMLElement {
            constructor() {
                super();
                const button = this.querySelector('button');
                if (!button) return;

                button.addEventListener('click', () => {
                    const modal = document.querySelector(this.getAttribute('data-modal'));
                    if (modal) modal.show(button);
                })
            }
        }
    );
}

if (!customElements.get('quick-add-modal')) {
    customElements.define(
        'quick-add-modal',
        class QuickAddModal extends HTMLElement {
            constructor() {
                super();
                this.modal = this.querySelector('.quick-add-modal__wrapper');
                this.modalContent = this.querySelector('[id^="QuickAddContent-"]');
                this.overlay = this.querySelector('.quick-add-modal__overlay');
                this.closeButton = this.querySelector('.quick-add-modal__close-btn');

                const timeline = gsap.timeline({
                    paused: true,
                    reversed: true
                })
                this.tl = timeline;
                this.animate()

                this.eventListeners();
            }

            connectedCallback() {
                if (this.moved) return;
                this.moved = true;
                document.body.appendChild(this);
            }

            animate() {
                this.tl.set(this.overlay, {
                    autoAlpha: 0
                });
                this.tl
                    .to(this, {
                        display: 'block',
                        autoAlpha: 1,
                        ease: 'Power3.inOut',
                        duration: 0.3
                    }, 0)
                    .fromTo(this.overlay, {
                        autoAlpha: 0,
                    }, {
                        autoAlpha: 1
                    }, 0)
                    .from(this.modal, {
                        y: "100%",
                        duration: 0.6,
                        ease: 'Power3.inOut'
                    }, 0.10);
            }

            show(opener) {
                opener.setAttribute('aria-disabled', true);
                fetch(opener.getAttribute('data-product-url'))
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                        this.productElement = responseHTML.querySelector('section[id^="MainProductQuickAdd-"]');
                        
                        if (!this.productElement) {
                            console.warn('Quick add product element not found in response');
                            return;
                        }

                        this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        this.tl.play();
                        this.tl.then(() => {
                            trapFocus(this, this.querySelector('[role="dialog"]'));
                        })
                        document.body.classList.add('quick-add-modal-open', 'overflow-hidden');
                    })
                    .catch(error => {
                        console.error('Error loading quick add modal:', error);
                    })
                    .finally(() => {
                        opener.removeAttribute('aria-disabled', true);
                    });
            }

            hide() {
                this.tl.reverse();
                this.tl.then(() => {
                    this.modalContent.innerHTML = '';
                    removeTrapFocus(this.openedBy);
                })
                document.body.classList.remove('quick-add-modal-open', 'overflow-hidden');
                document.body.dispatchEvent(new CustomEvent('modalClosed'));
            }

            setInnerHTML(element, html) {
                element.innerHTML = html;

                // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
                element.querySelectorAll('script').forEach((oldScriptTag) => {
                    const newScriptTag = document.createElement('script');
                    Array.from(oldScriptTag.attributes).forEach((attribute) => {
                        newScriptTag.setAttribute(attribute.name, attribute.value);
                    });
                    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                });
            }

            eventListeners() {
                this.closeButton.addEventListener('click', this.hide.bind(this))
                this.overlay.addEventListener('click', this.hide.bind(this))
                this.addEventListener('keyup', (event) => {
                    if (event.code.toUpperCase() === 'ESCAPE') this.hide().bind(this);
                });
            }
        }
    );
}